import { Contract } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import i18next from 'i18next';
import middleware from 'middleware';
import { useEffect } from 'react';
import {
  useGetChannelDistributionSectionTemplate,
  useGetChannelDistributionTemplateLightList,
} from 'services/templates/channel-distribution-template';
import { TEMPLATE_TYPE } from 'services/templates/types';
import { addItem, getExtremeId } from 'utils/dnd/dndUtilities';

const ContractSideMenuChannelDistribution = () => {
  const { values, setFieldValue, namePrefix, setErrors } = useFormikContractHelpers();

  const channelDistributionLightList =
    useGetChannelDistributionTemplateLightList();

  const selectedId = values.sideMenu?.customTemplate?.selectedId;

  const parentId = values.sideMenu?.customTemplate?.parentId;

  const channelDistributionTemplate = useGetChannelDistributionSectionTemplate(
    selectedId ?? '',
    {
      notFoundPath: undefined,
      notFoundToastError: i18next.t('toast-message.not-found'),
    },
    !!selectedId,
    false
  );

  useEffect(() => {
    if (!!selectedId && channelDistributionTemplate.data && parentId) {
      const contractTemplateForm = middleware.template.channelDistribution.queryToForm(
        channelDistributionTemplate.data,
        `${parseInt(getExtremeId(values.items)) + 1}`
      );

      const channelDistribution = contractTemplateForm[0].children[0];

      if (contractTemplateForm) {
        setFieldValue(
          namePrefix,
          addItem(values.items, parentId, channelDistribution)
        );
        setFieldValue('sideMenu', undefined);
        setErrors({})
      }
      console.log(
        'useEffect - channelDistributionTemplate',
        selectedId,
        channelDistributionTemplate.data
      );
    }
  }, [selectedId, channelDistributionTemplate.data]);

  return (
    <Contract.SideMenu.TemplatesList.Wrapper
      templates={channelDistributionLightList.data}
      templateType={TEMPLATE_TYPE.channelDistribution}
      item={template => (
        <Contract.SideMenu.TemplatesList.ListItem
          key={template.id}
          template={template}
        />
      )}
    />
  );
};

export default ContractSideMenuChannelDistribution;
